module.exports = __webpack_public_path__ + "static/img/Tela de orcamento.58cd103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de orcamento.png
// module id = LRD/
// module chunks = 0